export const SupplierUser = {
  ALL: { label: 'All', value: "all" },
  ADMIN: { label: 'Admin', value: "HC_SUPPLIER_ADMIN" },
  USER: { label: 'User', value: "HC_SUPPLIER_USER" }
};

